import { container } from 'tsyringe';
import { CampaignService } from '@/core/campaign/services/CampaignService';
import type { CurrentUser } from '@/core/user/models/CurrentUser';
import { GetMergeOptionsDTO } from '../DTO/GetMergeOptionsDTO';
import { Campaign } from '../models/Campaign';

export const getCampaignMergeOptionsUseCase = async (
  input: GetMergeOptionsDTO,
  user: CurrentUser,
): Promise<Campaign[]> => {
  const campaignService = container.resolve<CampaignService>('CampaignService');

  return await campaignService.getMergeOptions(input, user);
};
